import { forwardRef } from 'react';

import { Flex, type FlexProps } from '@frontend/legacy-components';

export type ViewerToolPanelProps = FlexProps;

/**
 * Card-style surface for floating viewer controls (sliders, compact tool rows) below the main tool strip.
 * Matches the main strip’s page surface, border, radius, and popover shadow.
 */
const ViewerToolPanel = forwardRef<HTMLDivElement, ViewerToolPanelProps>(
  ({ children, ...rest }, ref) => (
    <Flex
      ref={ref}
      h={'2.875rem'} // does not have corresponding value in the design system
      align="center"
      justify="center"
      direction="row"
      px={2}
      {...rest}
      bg="page.surface"
      border="1px solid"
      borderColor="separator.border"
      borderRadius="0.5rem"
      boxShadow="popover"
    >
      {children}
    </Flex>
  ),
);

ViewerToolPanel.displayName = 'ViewerToolPanel';

export default ViewerToolPanel;
